import type { SxProps, Theme } from "@mui/material/styles";

export const root: SxProps<Theme> = {
  flexDirection: "row",
  alignItems: "center",
  gap: 1.5,
  mt: 3.25,
  mb: 2.75,
};

export const line: SxProps<Theme> = {
  flex: 1,
  height: "1px",
  bgcolor: "divider",
};

export const label: SxProps<Theme> = {
  fontSize: "0.78125rem",
  color: "text.secondary",
};
